import { rootApi } from 'root-api'

const meetingShareApi = rootApi.injectEndpoints({
  endpoints: (build) => ({
    tagTypes: ['MeetingShares'],
    postMeetingShare: build.mutation({
      query: ({ event_uuid: eventUuid }) => ({
        url: '/api/meeting/shares',
        method: 'POST',
        data: { event_uuid: eventUuid }
      }),
      invalidatesTags: ['MeetingShares']
    }),
    patchMeetingSharePasscode: build.mutation({
      query: ({ share_uuid: shareUuid }) => ({
        url: `/api/meeting/shares/${shareUuid}/passcode`,
        method: 'PATCH',
      }),
      invalidatesTags: ['MeetingShares'],
    }),
    deleteMeetingSharePasscode: build.mutation({
      query: ({ share_uuid: shareUuid }) => ({
        url: `/api/meeting/shares/${shareUuid}/passcode`,
        method: 'DELETE',
      }),
      invalidatesTags: [('MeetingShares')],
    }),
    fetchMeetingShareByEventUuid: build.query({
      query: (eventUuid) => ({
        url: `/api/meeting/shares?event_uuid=${eventUuid}`,
      }),
      invalidatesTags: ['MeetingShares'],
    }),
    destroyMeetingShare: build.mutation({
      query: ({ event_uuid: eventUuid }) => ({
        url: '/api/meeting/shares',
        method: 'DELETE',
        data: { event_uuid: eventUuid },
      }),
      invalidatesTags: ['MeetingShares'],
    }),
    sendMeetingShareEmail: build.mutation({
      query: ({
        to_addresses: toAddresses,
        send_with: sendWith,
        subject,
        body,
        video_url: videoUrl,
        video_passcode: videoPasscode,
        segment_payload: segmentPayload
      }) => ({
        url: '/api/meeting/shares/email',
        method: 'POST',
        data: {
          to_addresses: toAddresses,
          send_with: sendWith,
          subject,
          body,
          video_url: videoUrl,
          video_passcode: videoPasscode,
          segment_payload: segmentPayload
        },
      }),
    }),
    fetchAttendeeFollowUpEmail: build.query({
      query: ({
        summary,
        event_uuid: eventUuid,
        hosts,
        invitees
      }) => ({
        url: '/api/followup',
        method: 'POST',
        data: {
          summary,
          event_uuid: eventUuid,
          hosts,
          invitees
        },
      }),
    }),
  }),
  overrideExisting: true
})

export const {
  usePostMeetingShareMutation,
  usePatchMeetingSharePasscodeMutation,
  useDeleteMeetingSharePasscodeMutation,
  useFetchMeetingShareByEventUuidQuery,
  useDestroyMeetingShareMutation,
  useSendMeetingShareEmailMutation,
  useFetchAttendeeFollowUpEmailQuery,
} = meetingShareApi
